const assert = require('#utils/browser-assert')
const { TransformMatrix2D } = require('#utils/transform-matrix')


function UnboundContext() {
  const stack = []
  let opts = {}
  let matrix = TransformMatrix2D()
  Object.assign(this, {
    save() {
      stack.push({
        matrix,
        opts: { ...opts },
      })
    },
    restore() {
      assert(stack.length > 0)
      const prev = stack.pop()
      opts = prev.opts
      matrix = prev.matrix
    },
    setOption(name, val) {
      opts[name] = val
    },
    setOptions(options) {
      for (const [name, val] of Object.entries(options)) {
        opts[name] = val
      }
    },
    getOption(name) {
      return opts[name]
    },
    getOptions() {
      return { ...opts }
    },
    transform(transformMatrix) {
      matrix = matrix.multiply(transformMatrix)
    },
    getTransform() {
      return matrix
    },
    resetTransform() {
      matrix = TransformMatrix2D()
    },
  })
}

module.exports = { UnboundContext }
